<h5>Pilot BE Study</h5>
<div style="margin-top:1.5rem;">
    <p-table [value]="StudyCosting" >
        <ng-template pTemplate="header">
            <tr>
                <th>Study design</th>
                <th>Total treatment period</th>
            </tr>
        </ng-template>
            <ng-template pTemplate="body" let-rowData style="font-size: 10px;">
                <tr>
                    <td>{{rowData.study_design}}</td>
              <td>{{rowData.total_treatment}}</td>
                </tr>
            </ng-template> 
    </p-table>
</div>
<div style="margin-top:1.5rem;">
    <p-table [columns]="columns" [value]="pilotStudyCosting">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns">
                    {{col.header}}
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
                <td *ngFor="let col of columns">
                    {{rowData[col.field]}}
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<h5  style="margin-top:1.5rem">Pivotal BE Study</h5>
<div style="margin-top:1.5rem;">
    <p-table [columns]="cols" [value]="StudyCosting" >
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns">
                    {{col.header}}
                </th>
            </tr>
        </ng-template>
            <ng-template pTemplate="body" let-rowData>
                <tr>
                    <td>{{rowData.study_design}}</td>
              <td>{{rowData.total_treatment}}</td>
                </tr>
            </ng-template> 
    </p-table>
</div>
<div style="margin-top:1.5rem;">
    <p-table [columns]="columns" [value]="pivotalStudyCosting">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns">
                    {{col.header}}
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
                <td *ngFor="let col of columns">
                    {{rowData[col.field]}}
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
<button class="btn btn-primary float-right" style="margin-top:1rem">Submit</button>


